import type { FC } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

export const ParcelQuestionmark: FC<SvgIconProps> = ({ viewBox = '0 0 255 170', ...props }) => (
  <SvgIcon viewBox={viewBox} {...props}>
    <path
      opacity="0.5"
      d="M81.3664 138.78L109.404 133.258L62.0375 109.681L34 115.203L81.3664 138.78Z"
      fill="url(#parcelQuestionmark_paint0_linear)"
    />
    <path d="M109.404 58.2787L192.667 43.4103L145.3 19.8333L62.0375 34.7017L109.404 58.2787Z" fill="#FDDE84" />
    <path
      opacity="0.4"
      d="M89.0129 48.0832L172.276 33.2149L164.417 29.3916L80.9415 44.26L89.0129 48.0832Z"
      fill="#AA7B33"
    />
    <path d="M109.404 58.2787V133.258L62.0375 109.681V34.7017L109.404 58.2787Z" fill="#C39000" />
    <path opacity="0.4" d="M89.0129 48.0832V64.4384L80.9415 60.1903V44.2599L89.0129 48.0832Z" fill="#AA7B33" />
    <path d="M109.404 58.2787V133.258L192.667 118.177V43.4103L109.404 58.2787Z" fill="#FCCE09" />
    <path
      d="M147.565 94.3876C147.565 88.4402 154.149 84.1921 154.362 77.6076C154.362 73.7843 152.025 72.7223 148.202 73.3595C143.954 74.2091 141.83 75.9083 140.768 76.758C140.555 73.5719 140.555 71.8726 140.343 68.6866C141.83 67.8369 145.865 65.9253 150.751 65.0757C158.61 63.5888 164.982 65.9253 164.982 73.9967C164.982 82.7053 156.273 89.0775 156.273 94.1752C156.273 94.6 156.273 94.8124 156.273 95.2372C152.875 95.8744 151.176 96.0868 147.777 96.7241C147.565 95.662 147.565 95.2372 147.565 94.3876ZM147.14 101.185C150.751 100.547 152.662 100.335 156.273 99.4853C156.273 103.309 156.273 105.22 156.273 109.044C152.662 109.681 150.751 110.106 147.14 110.53C147.14 106.92 147.14 105.008 147.14 101.185Z"
      fill="#C39000"
    />
    <defs>
      <linearGradient
        id="parcelQuestionmark_paint0_linear"
        x1="63.9802"
        y1="128.81"
        x2="71.5185"
        y2="112.714"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.25" stopOpacity="0" />
        <stop offset="0.598958" stopOpacity="0.3" />
        <stop offset="1" stopOpacity="0.8" />
      </linearGradient>
    </defs>
  </SvgIcon>
)
